module.exports = __webpack_public_path__ + "static/img/7.1.32049c50.png";